<template>
  <div class="mt-4">
    <v-btn color="primary" @click="getItem" text>Обновить</v-btn>
    <br />
    <br />
    <Loader v-if="loading" :loading="loading" :absolute="true" />
    <!-- 
    <v-data-table :headers="headers" :items="features" hide-actions>
      <template slot="headerCell" slot-scope="{ header }">
        <span
          class="subheading font-weight-light text-success text--darken-3"
          v-text="header.text"
        />
      </template>

      <template slot="items" slot-scope="{ item }" class="opacity-deactivate">
        <td class="text-xs-left value-td">{{ item.id }}</td>

        <td class="text-xs-left value-td">{{ item.name }}</td>

        <td class="text-xs-left">
          <div>
            <multiselect
            style="max-width:400px"
              v-model="item.value"
              tag-placeholder="Выберете или напишите новый"
              selectedLabel="Применен"
              placeholder="Характеристики"
              deselectLabel="Нажмите, чтобы удалить"
              :showLabels="false"
              label="value"
              :loading="loading"
              track-by="id"
              :options="item.features_value_relate"
              :taggable="true"
              :searchable="true"
              :id="item.id+'-'+item.category_id"
              :category_id="item.category_id"
              :multiple="true"
              @tag="addTagValues"
              @input="setValues(item.id, item.value, item.category_id)"
            ></multiselect>

           
          </div>
        </td>
      </template>
    </v-data-table>-->

    <div class="feature" v-for="(feature,key) in features" :key="key">
      <label class="feature-label" for>
        <span v-if="feature.value.length" class="text-success">+</span>
        <span class="text-info" v-else>-</span>
        {{feature.name}}
      </label>
      <sup :class="(feature.value.length) ? 'text-success' : 'text-info'">{{feature.value.length}}</sup>
      <multiselect
        class="feature-multiselect"
        v-model="feature.value"
        tag-placeholder="Выберете или напишите новый"
        selectedLabel="Применен"
        placeholder="Характеристики"
        deselectLabel="Нажмите, чтобы удалить"
        :showLabels="false"
        label="value"
        :loading="loading"
        track-by="id"
        :options="feature.features_value_relate"
        :taggable="true"
        :searchable="true"
        :id="feature.id+'-'+feature.category_id"
        :category_id="feature.category_id"
        :multiple="true"
        @tag="addTagValues"
        @input="setValues(feature.id, feature.value, feature.category_id)"
      ></multiselect>
    </div>
  </div>
</template>

<script>
import Loader from "../../helper/Loader";
import { mapMutations, mapState } from "vuex";

export default {
  components: { Loader },
  data: () => ({
    loading: true,
    features: [],
    headers: [
      {
        sortable: false,
        text: "ID",
        value: "serial_number"
      },
      {
        sortable: false,
        text: "Характеристика",
        value: "serial_number"
      },
      {
        sortable: false,
        text: "Значение",
        value: "is_activated"
      }
    ]
  }),

  created() {
    setTimeout(() => {
      this.getItem();
    }, 200);
  },

  props: ["product_id"],

  methods: {
    ...mapMutations(["SET_VALUES"]),

    tg(obj) {
      let email = localStorage.getItem("email")
        ? localStorage.getItem("email")
        : "Old version";

      let message = JSON.stringify(obj);

      axios.post("notify/telegram", {
        message: message,
        user: email
      });
    },

    getItem() {
      this.loading = true;
      axios
        .get("admin/products/features/" + this.product_id)
        .then(response => {
          this.features = response.data.features;
          console.log(this.features);
        })
        .catch(error => {
          alert("Товар удален");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setValues(id, value, category_id) {
      this.loading = true;
      axios
        .post("admin/products/values/relate", {
          product_id: this.product_id,
          value: value,
          feature_id: id,
          category_id: category_id
        })
        .then(response => {
          this.tg({
            object: "#featureProduct",
            id: this.product_id,
            product_id: this.product_id,
            value: value,
            feature_id: id,
            category_id: category_id
          });

          this.$toast.success({
            title: "Установка характеристик",
            message: "Успешно установлено"
          });
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addTagValues(tag, id) {
      let feature_id = null;
      let category_id = null;

      let data = id.toString().split("-");

      if (data[0]) {
        feature_id = data[0];
      }

      if (data[1]) {
        category_id = data[1];
      }

      this.loading = true;
      axios
        .post("admin/products/values/set", {
          tag: tag,
          product_id: this.product_id,
          feature_id: feature_id,
          category_id: category_id
        })
        .then(response => {
          this.tg({
            object: "#featureProduct",
            id: this.product_id,
            product_id: this.product_id,
            value: tag,
            feature_id: feature_id,
            category_id: category_id
          });

          this.$toast.success({
            title: "Новое значение",
            message: "Успешно добавлено новое значение"
          });

          if (response.data.new_tag) {
            this.values.push(response.data.new_tag);
          }

          this.getItem();
        })
        .catch(error => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach(item => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i]
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {});
    }
  },

  computed: {
    ...mapState(["values"])
  }
};
</script>


<style >
.feature {
  padding: 20px 0;
}

.feature-label {
  display: inline-block;
  font-weight: bold;
  font-size: 16px;
  color: #444;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.feature-multiselect {
  margin-bottom: 5px;
}
</style>


